import styled from 'styled-components';

export const EVisitsFeedItemSC = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 8px 0;
  padding: 7px 10px 7px 16px;
  border: 1px solid #d7d9e2;
  border-radius: 10px;
  background: #f5f5f7;

  cursor: pointer;

  .left {
    flex: 1;
    margin-right: 8px;
  }

  .type {
    width: 32px;
    height: 32px;
    padding: 8px;
    margin-right: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 50%;

    background: #62ab81;

    &.premium {
      background: #ff4496;
    }
  }

  .time {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    max-width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 24px;

    /* or 71% */

    color: rgba(24, 30, 52, 0.7);
  }

  .duration {
    padding-left: 8px;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;

    /* or 71% */

    display: flex;
    align-items: center;
    text-align: center;
    color: rgba(24, 30, 52, 0.7);
  }

  .patient {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 8px;

    .name {
      margin-left: 8px;
    }
  }

  .location {
    max-width: 50%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    .name {
      max-width: 100%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .badge {
      width: min-content;
      max-width: 100%;
      padding: 2px 8px;
      padding-bottom: 4px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-style: normal;
      font-weight: bold;
      font-size: 12px;
      line-height: 17px;
      color: white;
      background: #6ad5e5;
      border-radius: 14px;
    }
  }
`;
